// # Footer component with social links and information
import React, { useState } from "react";
import "./footer.css";
import { Link } from "react-router-dom";

function Footer() {
  // Add state for toggle
  const [showEmails, setShowEmails] = useState(false);

  return (
    <footer className="mn_fotr_main-footer">
      <div className="mn_fotr_footer-content">
        {/* # Left section */}
        <div className="mn_fotr_footer-left">
          <h3>Important Links</h3>
          <ul>
            <li>
              <i className="fas fa-question-circle"></i>
              <Link to="/faqs">FAQs</Link>
            </li>
            <li>
              <i className="fas fa-file-alt"></i>
              <Link to="/terms">Terms of Use</Link>
            </li>
            <li>
              <i className="fas fa-shield-alt"></i>
              <Link to="/privacy">Privacy Policy</Link>
            </li>
          </ul>
        </div>

        {/* # Center section - Brand */}
        <div className="mn_fotr_footer-center">
          <img
            src="/icons/TEMPU_Logo.png"
            alt="TEMP-U Logo"
            className="mn_fotr_footer-logo"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            role="button"
            title="Scroll to top"
          />
          <h4>TEMP-U</h4>
          <p>The Egyptian Mentorship Program for USMLE</p>
        </div>

        {/* # Right section */}
        <div className="mn_fotr_footer-right">
          <h3>Contact Us</h3>

          {/* Social links moved up */}
          {/* <div className="mn_fotr_social-links">
            <a 
              href="https://x.com/We_Are_TEMPU?t=hDMPUGfWyB8RiwiN2eaeWg&s=09" 
              target="_blank" 
              rel="noopener noreferrer"
              className="twitter"
            >
              <i className="fab fa-twitter"></i>
              <span>Twitter</span>
            </a>
            <a 
              href="https://www.facebook.com/share/1VMB4G1KWM/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="facebook"
            >
              <i className="fab fa-facebook"></i>
              <span>Facebook</span>
            </a>
          </div> */}

          {/* Email toggle section */}
          <div className="mn_fotr_email-container">
            <button
              className={`mn_fotr_email-toggle ${showEmails ? "active" : ""}`}
              onClick={() => setShowEmails(!showEmails)}
            >
              <i className="fas fa-envelope"></i>
              <span>Contact Emails</span>
              <i className={`fas fa-chevron-${showEmails ? "up" : "down"}`}></i>
            </button>

            <div
              className={`mn_fotr_email-list ${showEmails ? "expanded" : ""}`}
            >
              {/* Main Email */}
              <div className="mn_fotr_email-item mn_fotr_email-main">
                <i className="fas fa-envelope-open-text"></i>
                <a href="mailto:wearetempu@gmail.com">wearetempu@gmail.com</a>
              </div>
              {/* Support Email */}
              <div className="mn_fotr_email-item">
                <i className="fas fa-headset"></i>
                <a href="mailto:support@wearetempu.com">
                  support@wearetempu.com
                </a>
              </div>
              {/* Customer Service Email */}
              <div className="mn_fotr_email-item">
                <i className="fas fa-user-tie"></i>
                <a href="mailto:customer-service@wearetempu.com">
                  customer-service@wearetempu.com
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="mn_fotr_footer-bottom">
        <p>&copy; 2024 TEMP-U. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
